import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles/globals.css';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Register service worker for PWA capabilities
// US5: Remote Secure Voting - Offline support
// Only register in production to avoid conflicts with Vite HMR in development
if (import.meta.env.PROD) {
  serviceWorkerRegistration.register({
    onSuccess: () => {
      console.log('[PWA] App ready for offline use');
    },
    onUpdate: (_registration) => {
      console.log('[PWA] New version available');
      // User will be prompted to update via alert in serviceWorkerRegistration.ts
    },
    onOffline: () => {
      console.log('[PWA] Offline mode activated - votes will be queued');
      // Show offline banner
      const banner = document.createElement('div');
      banner.id = 'offline-banner';
      banner.className = 'offline-banner';
      banner.textContent = 'Sin conexión - tus votos se guardarán y enviarán automáticamente';
      document.body.appendChild(banner);
    },
    onOnline: () => {
      console.log('[PWA] Back online - syncing queued votes');
      // Remove offline banner
      const banner = document.getElementById('offline-banner');
      if (banner) {
        banner.remove();
      }
    },
  });
} else {
  // In development, unregister any existing service workers
  serviceWorkerRegistration.unregister();
}
